import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FunnelSimpleIcon } from '@phosphor-icons/react'

import { Button, Divider } from '@reveni-io/reveni-ui'

import FiltersDrawer from '@/common/components/FiltersDrawer/FiltersDrawer'
import QueryFilter from '@/common/components/QueryFilter/QueryFilter'
import { showClearFiltersButton } from '@/common/components/SelectedFilters/helpers'
import SelectedFilters from '@/common/components/SelectedFilters/SelectedFilters'

import { filterNames } from '../constants'
import { filterTypes, sections } from './constants'
import {
  applyFilters,
  clearAllFilters,
  filterFields,
  getDefaultFilterValue,
  getFilterLabel,
  getInitialFilters,
  isFilterValid,
} from './helpers'
import * as Styles from './styles'

const Filters = ({ filters, onChangeFilter, onApplyFilters, regions = [], productCategories = [] }) => {
  const { t } = useTranslation()
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false)

  const handleDeleteFilter = filterName => {
    if ([filterNames.weightGte, filterNames.weightLte].includes(filterName)) {
      onChangeFilter(filterNames.weightGte, null, false)
      onChangeFilter(filterNames.weightLte, null, true)
    } else if ([filterNames.unitCostGte, filterNames.unitCostLte].includes(filterName)) {
      onChangeFilter(filterNames.unitCostGte, null, false)
      onChangeFilter(filterNames.unitCostLte, null, true)
    } else {
      onChangeFilter(filterName, null, true)
    }
  }

  const handleClearFilters = () => {
    clearAllFilters(onChangeFilter)
  }

  const handleOpenDrawer = () => {
    setShowFiltersDrawer(true)
  }

  const handleCloseDrawer = () => {
    setShowFiltersDrawer(false)
  }

  const handleApplyDrawer = activeFilters => {
    applyFilters(activeFilters, onChangeFilter)
    onApplyFilters()
  }

  const hasActiveFilters = showClearFiltersButton(filters)
  const fieldProps = { regions, productCategories }
  const chipContext = { regions, productCategories }

  return (
    <>
      <Styles.Container>
        <QueryFilter
          placeholder={t('Nombre del producto, categoría, SKU, HS Code')}
          defaultValue={filters.query}
          onChange={query => onChangeFilter(filterNames.query, query)}
          onChangeValue={query => onChangeFilter(filterNames.query, query, false)}
        />
        <Button variant="text" size="s" onClick={handleOpenDrawer}>
          <FunnelSimpleIcon size={24} weight="light" />
          {hasActiveFilters ? t('Editar filtros') : t('Añadir filtro')}
        </Button>
      </Styles.Container>
      <SelectedFilters
        filters={filters}
        onDeleteFilter={handleDeleteFilter}
        onClickFilter={handleOpenDrawer}
        regions={regions}
        productCategories={productCategories}
      />
      <Divider />
      <FiltersDrawer
        show={showFiltersDrawer}
        onClose={handleCloseDrawer}
        onApply={handleApplyDrawer}
        onClearFilters={handleClearFilters}
        appliedFilters={filters}
        filterTypes={filterTypes}
        sections={sections}
        getInitialFilters={getInitialFilters}
        getDefaultFilterValue={getDefaultFilterValue}
        getFilterLabel={getFilterLabel}
        isFilterValid={isFilterValid}
        filterFields={filterFields}
        fieldProps={fieldProps}
        chipContext={chipContext}
      />
    </>
  )
}

export default Filters
